import type { Dictionary } from './en'

export const fr: Dictionary = {
    nav: {
        templates: 'Modèles',
        insights: 'Insights',
        cloneable: 'Cloneable',
        faq: 'FAQ',
        contact: 'Contact',
        allAccess: 'All-Access -95%',
        store: 'Boutique',
        moreStuff: 'Plus de super outils',
        topBanner: '95% DE RÉDUC sur TOUS les modèles',
        notification: '1 modèle Webflow OFFERT pour 2 achats – Réclamez le vôtre ! 💙🎉😍'
    },
    home: {
        badgeOff: '95% DE RÉDUC',
        badgePages: '1 300+ pages uniques',
        heroTitle: 'Créez des sites vite. Économisez gros',
        heroSubtitle: 'Accédez chaque jour à des centaines de modèles Webflow premium — payez une fois, créez de nombreux sites.',
        heroCta: 'Tout débloquer – 95% DE RÉDUC',
        allAccessTitle: 'Pass All-Access',
        allAccessLead: "Obtenez l'accès complet à la",
        allAccessLeadStrong: "bibliothèque entière au prix d'1 modèle",
        allAccessMid: 'boostez votre productivité avec un accès instantané à tous les',
        allAccessStrong2: '216 modèles',
        allAccessTail: 'et des nouveautés chaque mois.',
        allAccessCta: "Débloquer l'accès complet",
        categories: 'Catégories',
        tags: 'Tags',
        allCategories: 'Toutes les catégories',
        allTags: 'Tous les tags',
        searchCategories: 'Rechercher des catégories…',
        searchTags: 'Rechercher des tags…',
        noResults: 'Aucun résultat trouvé.',
        subscribeToDownload: "S'abonner pour télécharger",
        previous: 'Précédent',
        next: 'Suivant',
        noItems: 'Aucun élément trouvé.',
        loadMore: 'Voir plus',
        emptyTitle: 'Aucun modèle ne correspond à ces filtres',
        emptyBody: 'Essayez de retirer un filtre ou d’élargir votre recherche — ou parcourez toute la bibliothèque pour trouver votre modèle Webflow idéal.',
        clearFilters: 'Réinitialiser les filtres',
        browseAll: 'Voir tous les modèles'
    },
    footer: {
        tagline: 'Nous créons des modèles Webflow performants et qui convertissent.',
        product: 'Produit',
        unlockAllAccess: "Débloquer l'accès complet",
        templates: 'Modèles',
        ourFlow: 'Notre Flow',
        insights: 'Insights',
        giveaway: "Cadeau Sep '23 🎉",
        cloneable: 'Cloneable',
        tags: 'Tags',
        affiliate: 'Affiliation',
        other: 'Autres',
        contact: 'Contact',
        privacy: 'Confidentialité',
        faq: 'FAQ',
        followUs: 'Suivez-nous',
        topCategories: 'Catégories populaires',
        topTags: '#Tags populaires',
        mission: 'Notre mission : rendre possible la magie du code sans apprendre à coder.',
        emailPlaceholder: 'Adresse e-mail',
        subscribe: "S'abonner",
        subscribeSuccess: 'Merci ! Vérifiez votre boîte mail pour confirmer.',
        subscribeError: "Une erreur s'est produite. Veuillez réessayer."
    },
    templateDetail: {
        otherTemplates: 'Autres',
        otherTemplatesAccent: 'Webflow',
        otherTemplatesTail: 'modèles',
        webflow: 'Webflow',
        templateWord: 'Modèle',
        buyOnWebflow: 'Acheter sur Webflow',
        getThisMore: 'Obtenez celui-ci + 215 autres pour 69 $',
        orPreviewIn: 'Ou prévisualiser dans',
        browser: 'Navigateur',
        designer: 'Designer'
    },
    testimonials: {
        heading: 'On aime ce que',
        headingAccent: 'nous faisons'
    },
    blog: {
        readBlogPost: "Lire l'article",
        insightsAccent: 'Insights',
        fromWord: 'de',
        categoryWord: 'catégorie',
        otherInsights: 'Autres',
        otherInsightsAccent: 'Insights',
        mostRead: 'Articles les plus lus :',
        author: 'Auteur :',
        published: 'Publié',
        updated: 'Mis à jour',
        categoryLabel: 'Catégorie',
        share: 'Partager',
        subscribeInspo: "S'abonner à Wedoflow Inspo"
    },
    contact: {
        title: "Besoin d'aide avec votre site ?",
        subtitle: 'Posez des questions, partagez votre travail ou discutez avec notre équipe, écrivez-nous simplement.',
        startConversation: 'Démarrer la conversation',
        getInTouch: 'Contactez-nous',
        emailPlaceholder: 'Votre e-mail',
        companyPlaceholder: "Nom de l'entreprise",
        messagePlaceholder: 'Message',
        submit: 'Envoyer',
        sending: 'Veuillez patienter...',
        success: 'Merci ! Votre message a bien été reçu !',
        error: "Oups ! Une erreur s'est produite lors de l'envoi."
    },
    marketplace: {
        otherTemplates: 'Autres',
        otherTemplatesAccent: 'modèles Webflow'
    },
    common: {
        loading: 'Chargement…',
        backToHome: "Retour à l'accueil",
        readMore: 'Lire la suite',
        viewTemplate: 'Voir le modèle',
        from: 'À partir de',
        notFoundTitle: 'Page introuvable',
        notFoundText: "La page que vous cherchez n'existe pas ou a été déplacée."
    }
}
